import React from 'react';
import '../styles/PageSidebar.css';
import PageSidebarCategoryList from './PageSidebarCategoryList';
import { GiHamburgerMenu } from 'react-icons/gi';


const PageSidebar = () => {
    return (
        <div
            className={'page-sidebar--container'}
        >
            <div
                className={'page-sidebar--section'}
            >
                <h3
                    className={'page-sidebar--heading'}
                >
                    <GiHamburgerMenu 
                        className={'page-sidebar--icon'}
                    /> ALL CATEGORIES
                </h3>
                <PageSidebarCategoryList />
            </div>
        </div>
    );
};

export default PageSidebar;
